import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import '../App.css';
import '../popup.css';

// Centrado del modal como parte de la clase (antes iba como style inline en el DOM,
// prohibido por react/forbid-dom-props).
const centered = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
};

const useStyles = makeStyles((theme) => ({
    paper: {
        ...centered,
        fontFamily: 'WorkSans',
        position: 'absolute',
        width: 'min(588px, 95vw)',
        maxHeight: '90vh',
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '0px 0px 0px 0px',
    },
}));

const useStyles1 = makeStyles((theme) => ({
    paper: {
        ...centered,
        fontFamily: 'WorkSans',
        position: 'absolute',
        width: 'min(1300px, 95vw)',
        maxHeight: '90vh',
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '0px 0px 0px 0px',
    },
}));

function ModalR(props) {
    const classes = useStyles();
    const classes1 = useStyles1();
    const selcClass = props.popupFlag ? classes1.paper : classes.paper;

    const body = (
        <div className={selcClass}>
            <div id="simple-modal-title">{props.popupTitle}</div>
            <div id="simple-modal-description">{props.popupBody}</div>
        </div>
    );

    return (
        <div>
            <Modal
                open={props.open}
                // onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}

ModalR.defaultProps = {
    textButton: 'Agregar',
    colorButton: 'primary',
    popupTitle: 'Titulo',
    popupPrimButton: 'Aceptar',
    popupSeconButton: 'Cancelar',
    popupsbclass: 'popupbp',
    isContained: 'contained',
};

export default ModalR;
